/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */
export default [
  {
    path: '/',
    name: 'Pessoas',
    view: 'person/List',
    meta: {requiresAuth: true},
    icon: 'mdi-account-card-details',

  },


  {
    path: '/persons',
    view: 'person/List',
    name: 'Pessoas ',
    meta: {requiresAuth: true},
    menu: false,

  },


  {
    path: '/persons/:id/edit/',
    view: 'person/Create',
    name: 'Editar Pessoa',
    meta: {requiresAuth: true},
    menu: false,

  },

  {
    path: '/persons/create',
    view: 'person/Create',
    name: 'Cadastrar Pessoa',
    meta: {requiresAuth: true},
    menu: false,

  },
  {
    path: '/persons/:id/fingerprints',
    view: 'person/Fingerprints',
    name: 'Digitais',
    meta: {requiresAuth: true},
    menu: false,

  },
  {
    path: '/persons/:id/grant',
    view: 'person/Grant',
    name: 'Conceder Acesso',
    meta: {requiresAuth: true},
    menu: false,

  },
  {
    path: '/persons/:id/accesslog',
    view: 'person/AccessLog',
    name: 'Histórico de Acesso',
    meta: {requiresAuth: true},
    menu: false,

  },
  {
    path: '/accounts/',
    name: 'Contas',
    view: 'account/List',
    icon: 'mdi-account',
    meta: {requiresAuth: true, requiresAdmin: true},
  },


  {
    path: '/accounts/:id/edit/',
    name: 'Editar Conta',
    view: 'account/Create',
    menu: false,
    meta: {requiresAuth: true, requiresAdmin: true},
  },
  {
    path: '/accounts/create/',
    name: 'Criar',
    view: 'account/Create',
    menu: false,
    meta: {requiresAuth: true, requiresAdmin: true},
  },
  {
    path: '/equipments/',
    name: 'Equipamentos',
    view: 'equipment/List',
    icon: 'mdi-door-open',
    meta: {requiresAuth: true, requiresAdmin: true},
  },


  {
    path: '/equipments/:id/edit/',
    name: 'Editar Equipamento',
    view: 'equipment/Create',
    menu: false,
    meta: {requiresAuth: true, requiresAdmin: true},
  },
  {
    path: '/equipments/create/',
    name: 'Criar Equipamento',
    view: 'equipment/Create',
    menu: false,
    meta: {requiresAuth: true, requiresAdmin: true},
  },

  {
    path: '/equipments/:id/accesslog',
    view: 'equipment/AccessLog',
    name: 'Histórico de Acesso Equipamento',
    meta: {requiresAuth: true},
    menu: false,

  },
  {
    path: '/user-profile/:id?',
    name: 'User Profile',
    view: 'UserProfile',
    icon: 'mdi-account',
    menu: false,
    meta: {requiresAuth: true},
  },

  {
    path: '/icons',
    view: 'Icons',
    icon: 'mdi-chart-bubble',
    meta: {requiresAuth: true},
    menu: false,

  },

  {
    path: '/dashboard',
    // Relative to /src/views
    view: 'Dashboard',
    meta: {requiresAuth: true},
    menu: false,
    icon: 'mdi-view-dashboard',
  },

  {
    path: '/login',
    name: 'Login',
    view: 'Login',
    menu: false,
    meta: {plainLayout: true},
  },
  {
    path: '/not-found',
    name: 'Não Encontrado',
    menu: false,
    view: 'NotFound',
  },
]
